var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { AdminLayout } from "src/Layouts";
import { BLOCKED_DATE_SUCCESS_MESSAGE, CREATE_BLOCKED_DATE, ROUTES } from "src/Utils";
import { Container, Title, InnerContainer, SuccessSnackbar } from "./styles";
import { BlockerForm } from "./BlockerForm/BlockerForm";
import { FormProvider, useForm } from 'react-hook-form';
import { createBlockedDate } from './services';
var CreateBookingBlockedDate = function () {
    var push = useHistory().push;
    var methods = useForm({
        defaultValues: {
            building: null,
            amenity: null,
            isRecurring: false,
            date: null,
            general_block: false,
        },
    });
    var register = methods.register, watch = methods.watch;
    var _a = watch(), building = _a.building, amenity = _a.amenity, isRecurring = _a.isRecurring, date = _a.date, general_block = _a.general_block;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var handleClick = function () { return setOpen(true); };
    var handleClose = function (event, reason) {
        if (reason === 'clickaway')
            return;
        setOpen(false);
        push(ROUTES.booking_blocked_dates);
    };
    var mutateCreateBlockedDate = useMutation(createBlockedDate, {
        onSuccess: function () {
            handleClick();
            setTimeout(function () { return push(ROUTES.booking_blocked_dates); }, 2000);
        },
    })[0];
    var handleCreateBlockedDate = function () {
        if (!date)
            return;
        var data = {
            date: date.toString(),
            general_block: general_block,
            recurring: isRecurring,
            entity_id: (amenity === null || amenity === void 0 ? void 0 : amenity.value) || (building === null || building === void 0 ? void 0 : building.value),
            entity_type: (amenity === null || amenity === void 0 ? void 0 : amenity.value) ? 'Amenity' : 'Building',
        };
        mutateCreateBlockedDate(data);
    };
    React.useEffect(function () {
        register('building');
        register('amenity');
        register('isRecurring');
        register('date');
        register('general_block');
    }, [register]);
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, CREATE_BLOCKED_DATE),
            React.createElement(InnerContainer, null,
                React.createElement(FormProvider, __assign({}, methods),
                    React.createElement(BlockerForm, { handleCreateBlockedDate: handleCreateBlockedDate })))),
        React.createElement(SuccessSnackbar, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, open: open, autoHideDuration: 2000, onClose: handleClose, message: BLOCKED_DATE_SUCCESS_MESSAGE, action: React.createElement(IconButton, { size: "small", color: "inherit", onClick: handleClose },
                React.createElement(CloseIcon, { fontSize: "small" })) })));
};
export default CreateBookingBlockedDate;
